/* eslint-disable simple-import-sort/sort */
import {
    UPDATE_SEARCH_BAR,
    UPDATE_SEARCH_LOAD_STATUS,
    CLEAR_SEARCH_RESULTS,
    updateSearchBar,
    updateLoadStatus,
    clearSearchResults
} from 'SourceStore/SearchBar/SearchBar.action';

export {
    UPDATE_SEARCH_BAR,
    UPDATE_SEARCH_LOAD_STATUS,
    CLEAR_SEARCH_RESULTS,
    updateSearchBar,
    updateLoadStatus,
    clearSearchResults
};

export const UPDATE_SEARCH_PAGE = 'UPDATE_SEARCH_PAGE';
export const UPDATE_SEARCH_PAGE_LOAD_STATUS = 'UPDATE_SEARCH_PAGE_LOAD_STATUS';

/** @namespace PeggysagePwa/Store/SearchBar/Action/updateSearchPage */
export const updateSearchPage = (result) => ({
    type: UPDATE_SEARCH_PAGE,
    resultPage: result
});

/** @namespace PeggysagePwa/Store/SearchBar/Action/updatePageLoadStatus */
export const updatePageLoadStatus = (status) => ({
    type: UPDATE_SEARCH_PAGE_LOAD_STATUS,
    isLoadingPage: status
});
